// The MIT License (MIT)
//
// Copyright (c) 2016-2024 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/mobile.scss';

import angular from 'angular';
import ngeoMessageModalComponent from 'ngeo/message/modalComponent';
import gmfControllersAbstractMobileController, {
  AbstractMobileController,
} from 'gmf/controllers/AbstractMobileController.js';
import nyonBase from '../nyonmodule.js';

/**
 * @private
 */
class Controller extends AbstractMobileController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   */
  constructor($scope, $injector, $http) {
    super($scope, $injector);
    /**
     * @type {angular.$locale} $locale Angular locale
     * @private
     */
    this.$locale_ = $injector.get('$locale');
    // Set manually locale number format.
    $scope.$on('$localeChangeSuccess', (ev) => {
      this.$locale_.NUMBER_FORMATS.DECIMAL_SEP = '.';
      this.$locale_.NUMBER_FORMATS.GROUP_SEP = "'";
    });

    // Get full entry point
    const pathname = location.pathname;
    const pathnameSplit = pathname.split('/');
    const tag = pathnameSplit[1];
    const urlDomain = location.hostname;
    const substring = pathname.substring(0, 7);

    if (substring == '/mobile' || substring == '/') {
      this.url = 'https://' + urlDomain;
    } else {
      this.url = 'https://' + urlDomain + '/' + tag;
    }

    // Get metadata info for copyright
    $http.get(this.url + '/background_metadata').then((resp) => {
      $scope.metadatas = resp.data.metadata;
    });
  }
}

Controller.$inject = ['$scope', '$injector', '$http'];

/**
 * @hidden
 */
const nyonModule = angular.module('Appmobile', [
  nyonBase.name,
  gmfControllersAbstractMobileController.name,
  ngeoMessageModalComponent.name,
]);

nyonModule.controller('MobileController', Controller);

export default nyonModule;
